<template>
  <div style="flex: 1">
    <div class="history-number title-table">
      <div class="title">开奖号码</div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th>期号</th>
            <th>号码</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data">
            <td>{{ item.qihao }}</td>
            <td style="display: flex; align-items: center">
              <div style="margin: 0 5px" :class="'ball ball' + item.q1"></div>
              <div style="margin: 0 5px" :class="'ball ball' + item.q2"></div>
              <div style="margin: 0 5px" :class="'ball ball' + item.q3"></div>
              <div style="margin: 0 5px" :class="'ball ball' + item.q4"></div>
              <div style="margin: 0 5px" :class="'ball ball' + item.q5"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="beted-number title-table">
      <div class="title">目前停押号码</div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th>号码</th>
            <th>金额</th>
            <th>
              <el-checkbox class="checkbox black-text dark">全选</el-checkbox>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "QDKaiJiang",
  data() {
    return {
      data: [],
    };
  },
  methods: {
    initData() {
      this.getOpenLit();
    },
    getOpenLit() {
      let access_token = this.$store.state.userInfo.access_token;
      let uid = this.$store.state.userInfo.uid;
      let code = this.$store.state.gameInfo[0].code;
      let data = {
        access_token,
        uid,
        code,
      };
      this.$http.postAxiosMethod("/user/openinfomore", data).then((res) => {
        this.data = res.data.slice(0, 5);
      });
    },
  },
  created() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.title-table {
  width: 300px;
  margin-bottom: 20px;
  .title {
    height: 30px;
    line-height: 30px;
    background: var(--new-bg-primary);
    text-align: center;
    color: var(--new-text-primary-bg);
    border-radius: 10px 10px 0 0;
  }
  table {
    background: #fff;
    border: 1px solid var(--new-border);
    th,
    td {
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-right: 1px solid var(--new-border);
      border-bottom: 1px solid var(--new-border);
    }
  }
}
</style>
